import { uiActions } from "../ui-slice";
import { dashActions } from "./dash-slice";

export const GetDashById = (id, userId) => {
  return async (dispatch) => {
    const GetUserByIdInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}dash/get-dash-by-id/${id}/${userId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response;
    };
    try {
      const response = await GetUserByIdInfo();

      if (response.ok) {
        const dash = await response.json();

        dispatch(dashActions.setDash(dash));
      } else {
        const message = await response.json();

        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: message.detail,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Ocurrio un error",
        })
      );
    }
  };
};
